import { genericToolTip } from '@y42/gojs';
import { JobStatusToIcon } from '@y42/job';
import { JobStatus } from '@y42/json-schema';
import * as go from 'gojs';
import { OrchestrationNodeBindings, OrchestrationUINode } from '../../../../models/orchestration-diagram.model';
import { orchestrationDiagramConfig } from '../../../config/orchestration-diagram.config';
import { visibleInOverview } from '../utils/bindings';

const $ = go.GraphObject.make;

export const NodeJobStatus = () =>
  $(
    go.Panel,
    go.Panel.Auto,
    {
      toolTip: Tooltip(),
      visible: false,
    },
    visibleInOverview(),
    StatusPicture(),
  );

const StatusPicture = () =>
  $(
    go.Picture,
    {
      desiredSize: new go.Size(25, 25),
      imageStretch: go.GraphObject.Uniform,
      margin: new go.Margin(0, 5, 0, 0),
    },
    statusImgSourceBinding(),
  );

const statusImgSourceBinding = () =>
  new go.Binding('source', '', (node: OrchestrationUINode) => {
    return `${node.jobStatus ? JobStatusToIcon[node.jobStatus].icon : JobStatusToIcon[JobStatus.New].icon}`;
  });

const Tooltip = () =>
  genericToolTip(orchestrationDiagramConfig.tooltip, [
    new go.Binding('text', '', (node: OrchestrationUINode) =>
      node[OrchestrationNodeBindings.JobStatus]
        ? NodeJobStatusTooltipMessages[node[OrchestrationNodeBindings.JobStatus]!]
        : 'Waiting',
    ),
  ]);

const NodeJobStatusTooltipMessages: Record<JobStatus, string> = {
  [JobStatus.New]: 'New',
  [JobStatus.Queued]: 'Queued',
  [JobStatus.Pending]: 'Pending',
  [JobStatus.Ready]: 'Ready',
  [JobStatus.Invalid]: 'Invalid',
  [JobStatus.InvalidPartial]: 'Partially Invalid',
  [JobStatus.PartiallyEmpty]: 'Partially Empty',
  [JobStatus.PartiallyReady]: 'Partially Ready',
  [JobStatus.Expired]: 'Expired',
  [JobStatus.Canceled]: 'Canceled',
};
